// Mock data pour le système d'alertes

import icon from './avatar.jpg';

export const mockAlerts = [
    {
        "_id": "684cb0ed5e4472808f6718cd",
        "createdBy": "68177e5b015bb1018427e2d3",
        "deleted": false,
        "description": "Scanner en panne depuis deux semaines",
        "category": "67ae0979f2e624a44a7cf5ca",
        "location": {
            "latitude": 14.662305799999999,
            "longitude": -17.4351994,
            "shortCode": "7C64MH67+WW",
            "displayName": "Hopital Principal de Dakar"
        },
        "status": "NEW",
        "medias": [],
        "createdAt": "2025-06-13T23:14:53.876Z",
        "updatedAt": "2025-06-13T23:14:53.876Z"
    },
    {
        "_id": "684cb0ed5e4472808f6718ce",
        "createdBy": "68177e5b015bb1018427e2d4",
        "deleted": false,
        "description": "Problème d'éclairage public dans le quartier",
        "category": "67ae0979f2e624a44a7cf5cb",
        "location": {
            "latitude": 14.692271,
            "longitude": -17.447938,
            "shortCode": "7C64MH67+XX",
            "displayName": "Plateau, Dakar"
        },
        "status": "RESOLVED",
        "medias": [],
        "createdAt": "2025-06-12T15:30:20.123Z",
        "updatedAt": "2025-06-14T10:45:30.456Z"
    },
    {
        "_id": "684cb0ed5e4472808f6718cf",
        "createdBy": "68177e5b015bb1018427e2d5",
        "deleted": false,
        "description": "Route dégradée après les pluies",
        "category": "67ae0979f2e624a44a7cf5cc",
        "location": {
            "latitude": 14.716667,
            "longitude": -17.466667,
            "shortCode": "7C64MH67+YY",
            "displayName": "Parcelles Assainies"
        },
        "status": "RESOLVED",
        "medias": [],
        "createdAt": "2025-06-10T08:15:10.789Z",
        "updatedAt": "2025-06-15T16:20:45.123Z"
    },
    {
        "_id": "684cb0ed5e4472808f6718d0",
        "createdBy": "68177e5b015bb1018427e2d6",
        "deleted": false,
        "description": "Coupure d'eau dans le secteur depuis 3 jours",
        "category": "67ae0979f2e624a44a7cf5cd",
        "location": {
            "latitude": 14.7528,
            "longitude": -17.4924,
            "shortCode": "7C64MH67+ZZ",
            "displayName": "Guédiawaye"
        },
        "status": "NEW",
        "medias": [],
        "createdAt": "2025-06-16T12:45:30.456Z",
        "updatedAt": "2025-06-16T12:45:30.456Z"
    },
    {
        "_id": "684cb0ed5e4472808f6718d1",
        "createdBy": "68177e5b015bb1018427e2d7",
        "deleted": false,
        "description": "Problème de sécurité - éclairage défaillant",
        "category": "67ae07bdf2e624a44a7cf5b2",
        "location": {
            "latitude": 14.7645,
            "longitude": -17.3660,
            "shortCode": "7C64MH67+AA",
            "displayName": "Pikine"
        },
        "status": "CLOSED",
        "medias": [],
        "createdAt": "2025-06-17T19:30:15.789Z",
        "updatedAt": "2025-06-17T19:30:15.789Z"
    }
];

export const mockCategories = [
    {
        "_id": "67ae07bdf2e624a44a7cf5b2",
        "title": "Insécurité",
        "severity": "MODERATE",
        "order": 1,
        "icon": icon
    },
    {
        "_id": "67ae0979f2e624a44a7cf5ca",
        "title": "Équipement médical",
        "severity": "HIGH",
        "order": 2,
        "icon": icon
    },
    {
        "_id": "67ae0979f2e624a44a7cf5cb",
        "title": "Éclairage public",
        "severity": "LOW",
        "order": 3,
        "icon": icon
    },
    {
        "_id": "67ae0979f2e624a44a7cf5cc",
        "title": "Infrastructure routière",
        "severity": "MODERATE",
        "order": 4,
        "icon": icon
    },
    {
        "_id": "67ae0979f2e624a44a7cf5cd",
        "title": "Distribution d'eau",
        "severity": "HIGH",
        "order": 5,
        "icon": icon
    }
];

export const mockUsers = [
    {
        "_id": "68177e5b015bb1018427e2d3",
        "fullName": "ADMINISTRATEUR",
        "deleted": false,
        "phoneNumber": "+221776543210",
        "authID": "bf6d386f-g849-5ea3-9f92-5e479416928d",
        "role": "ADMIN",
        "createdAt": "2025-01-15T09:15:30.123Z",
        "updatedAt": "2025-07-07T14:30:20.456Z",
        "createdBy": "System",
        "email": "admin@alerts.sn",
        "fullName": "Administrateur Système"
    },
    {
        "_id": "68177e5b015bb1018427e2d4",
        "fullName": "MOUSSA NDIAYE",
        "deleted": false,
        "phoneNumber": "+221775432109",
        "authID": "cf7e497g-h95a-6fb4-ag93-6f58a527a39e",
        "role": "USER",
        "createdAt": "2025-02-10T14:20:45.789Z",
        "updatedAt": "2025-07-05T11:15:30.123Z",
        "createdBy": "Anonymous",
        "email": "fatou.diop@email.com",
        "fullName": "FATOU DIOP"
    },
];

export const mockAnalytics = {
    totalAlerts: 0,
    newAlerts: 0,
    closedAlerts: 0,
    resolvedAlerts: 0,
    alertsByCategory: [],
    alertsByStatus: [],
    alertsByMonth: [],
    recentAlerts: []
};